<template>
  <div>
    <div class="das-form-container">
      <div class="das-form-title-container">
        <div class="das-form-title">
          <div class="main-title">Thông tin khách hàng</div>
        </div>
      </div>
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-12">
            <InfoList
              :columns="3"
              :column-breakpoint-options="{
                sm: 1,
                md: 3
              }"
            >
              <template>
                <InfoListLabel>Đến/Đi</InfoListLabel>
                <InfoListValue
                  >{{ $displayDate(bookingInfo.check_in_date) }} -
                  {{ $displayDate(bookingInfo.check_out_date) }}</InfoListValue
                >

                <!-- <InfoListLabel>Giá</InfoListLabel>
                <InfoListValue>20,000 VND</InfoListValue> -->

                <InfoListLabel>Tổng tiền</InfoListLabel>
                <InfoListValue
                  >{{ $displayCurrency(emitedMoney) }} VND</InfoListValue
                >

                <InfoListLabel>Tổng đặt cọc</InfoListLabel>
                <InfoListValue
                  >{{ $displayCurrency(depositMoney) }} VND</InfoListValue
                >

                <!-- <InfoListLabel>VIP</InfoListLabel>
                <InfoListValue>1 VND</InfoListValue> -->
              </template>
            </InfoList>
          </div>
        </div>
        <div class="das-form-row">
          <div class="flex-1" style="overflow: auto">
            <div class="das-form-input flex flex-col" style="height: 100%">
              <div class="label">Ghi chú</div>
              <div class="child-w-80 flex-1 flex">
                <!-- <ul class="warnings-wrap">
                  <li v-for="(item, index) in warningDescArray" :key="index">
                    {{ item }}
                  </li>
                </ul> -->
                <!-- :value="updateNoteData.note" -->
                <textarea
                  readonly
                  :value="updateNoteData.note"
                  style="width: 100%; height: 100%; white-space: pre-wrap"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="sub-button-container">
            <div class="label">Chức năng</div>
            <div class="flex gap-10 mb-10">
              <button
                v-if="bookingInfo.checked_out"
                style="width: 150px"
                class="btn mini pink"
                :disabled="!isRowSelected || bookingInfo.status == 1"
                @click="onCancelCheckoutCustomer"
              >
                Hủy trả phòng
              </button>
              <button
                v-else
                style="width: 150px"
                class="btn mini pink"
                :disabled="
                  !checkoutPermit || !isRowSelected || bookingInfo.status == 1
                "
                @click="onCheckoutCustomer"
              >
                Trả phòng
              </button>
              <button
                :disabled="
                  !checkoutPermit ||
                  !isRowSelected ||
                  !bookingInfo.group_master ||
                  !bookingInfo.is_group ||
                  bookingInfo.status == 1
                "
                class="btn primary mini"
                style="width: 150px"
                @click="onCheckoutGroup"
              >
                Trả phòng đoàn
              </button>
            </div>
            <div class="flex flex-1 gap-10 sub-button-wrap">
              <button
                style="width: 97px"
                class="btn primary mini"
                :disabled="!isRowSelected || bookingInfo.status == 1"
                @click="openRoutingDialog"
              >
                Routing
              </button>
              <button
                v-if="checkAuthorPermission"
                style="width: 97px"
                class="btn primary mini"
                :disabled="!isRowSelected || bookingInfo.status == 1"
                @click="openMissionDialog"
              >
                Nhiệm vụ
              </button>
              <button
                v-if="checkAuthorComment"
                style="width: 96px"
                class="btn primary mini"
                :disabled="!isRowSelected || bookingInfo.status == 1"
                @click="openCommentDialog"
              >
                Bình luận
              </button>
              <button
                v-if="checkAuthorWarning"
                class="btn primary mini"
                :disabled="!isRowSelected"
                @click="openWarningDialog"
              >
                Ghi chú
              </button>
              <button
                class="btn primary mini"
                :disabled="!isRowSelected || bookingInfo.status == 1"
                @click="openMessageDialog()"
              >
                Tin nhắn
              </button>
              <button
                class="btn primary mini"
                :disabled="!isRowSelected || bookingInfo.status == 1"
                @click="editReservationInfo()"
              >
                Sửa đặt phòng
              </button>
            </div>
            <div class="checkout-inspection-status">
              Kiểm phòng CO: {{ checkoutInspectionStatusText }}
            </div>
            <div class="flex gap-10 checkout-inspection-actions">
              <button
                v-if="showRequestCheckoutInspection"
                class="btn primary mini"
                :disabled="!canRequestCheckoutInspection || checkoutInspectionBusy"
                @click="requestCheckoutInspection"
              >
                Yêu cầu kiểm phòng CO
              </button>
              <button
                v-if="checkoutInspectionStatus === 'PENDING'"
                class="btn primary mini"
                :disabled="checkoutInspectionBusy"
                @click="cancelCheckoutInspection"
              >
                Hủy yêu cầu kiểm
              </button>
              <button
                v-if="hasCheckoutInspectionSlip"
                class="btn primary mini"
                @click="openCheckoutInspectionSlip"
              >
                Xem phiếu
              </button>
            </div>
            <!-- <div class="das-form-input">
              <div class="label">Mô tả</div>
              <div class="child-w-80">
                <textarea rows="5" readonly />
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- DIALOG =============================================== -->
    <el-dialog
      :title="`Phiếu kiểm phòng ${checkoutInspectionSlipData.room_num || bookingInfo.room_num || ''}`"
      :visible.sync="checkoutInspectionDialog"
      :close-on-click-modal="false"
      width="720px"
    >
      <div v-if="checkoutInspectionSlipData.slip">
        <div class="checkout-inspection-meta">
          <div><span class="checkout-inspection-label">Người gửi:</span> {{ checkoutInspectionSlipData.slip.sent_by || checkoutInspectionSlipData.sent_by || '' }}</div>
          <div><span class="checkout-inspection-label">Thời gian gửi:</span> {{ formatCheckoutInspectionTime(checkoutInspectionSlipData.slip.sent_at) }}</div>
        </div>
        <div class="checkout-inspection-divider" />
        <div v-if="checkoutInspectionSlipData.slip.no_charge">
          Không phát sinh minibar/đền bù.
        </div>
        <template v-else>
          <el-table :data="checkoutInspectionSlipData.slip.items || []">
            <el-table-column label="Nhóm" width="110">
              <template slot-scope="scope">{{ checkoutInspectionGroupName(scope.row.group) }}</template>
            </el-table-column>
            <el-table-column prop="name" label="Món" min-width="160" />
            <el-table-column prop="quantity" label="SL" width="55" />
            <el-table-column label="Đơn giá" width="115" align="right">
              <template slot-scope="scope">{{ $displayCurrency(scope.row.unit_price) }}</template>
            </el-table-column>
            <el-table-column label="Thành tiền" width="125" align="right">
              <template slot-scope="scope">{{ $displayCurrency(scope.row.total) }}</template>
            </el-table-column>
          </el-table>
          <div class="checkout-inspection-total">
            Tổng: {{ $displayCurrency(checkoutInspectionSlipData.slip.total) }} VND
          </div>
        </template>
        <div class="checkout-inspection-note">
          Phiếu giữ nguyên nội dung HK gửi; điều chỉnh bằng Sửa giao dịch.
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn primary small" @click="checkoutInspectionDialog = false">
          Đóng
        </button>
      </span>
    </el-dialog>
    <!-- List Routing Popup -->
    <el-dialog
      title="Routing"
      :visible.sync="routingDialog"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-group-title">Từ Folio</div>
          <InfoList :columns="3">
            <InfoListLabel>Số Folio</InfoListLabel>
            <InfoListValue>{{ bookingInfo.sub_booking_code }}</InfoListValue>

            <InfoListLabel>Tên</InfoListLabel>
            <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

            <InfoListLabel>Số phòng</InfoListLabel>
            <InfoListValue>{{ bookingInfo.room_num }}</InfoListValue>
          </InfoList>
        </div>
      </div>
      <div class="mt-10" style="height: 400px">
        <GridVx
          ref="routingGrid"
          :columns="routingCols"
          dom-layout="scroll"
          :rows="routingRows"
          class="agGrid"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="routingDialog = false">
            Đóng
          </button>
          <button class="btn primary small" @click="addRouting">Thêm</button>
          <button class="btn primary small" @click="editRouting">Sửa</button>
          <button class="btn primary small outline" @click="deleteRouting">
            Xóa
          </button>
        </div>
      </span>
    </el-dialog>

    <!-- List Routing Popup -->
    <el-dialog
      title="Routing"
      :visible="routingDialog"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-group-title">Từ Folio</div>
          <InfoList
            :columns="3"
            :column-breakpoint-options="{
              sm: 1,
              md: 3,
              lg: 3,
              xl: 3
            }"
          >
            <InfoListLabel>Số Folio</InfoListLabel>
            <InfoListValue>{{ bookingInfo.sub_booking_code }}</InfoListValue>

            <InfoListLabel>Tên</InfoListLabel>
            <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

            <InfoListLabel>Số phòng</InfoListLabel>
            <InfoListValue>{{ bookingInfo.room_num }}</InfoListValue>
          </InfoList>
        </div>
      </div>
      <div class="mt-10" style="height: 400px">
        <GridVx
          ref="routingGrid"
          :columns="routingCols"
          dom-layout="scroll"
          :rows="routingRows"
          class="agGrid"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="routingDialog = false">
            Đóng
          </button>
          <button class="btn primary small" @click="addRouting">Thêm</button>
          <button class="btn primary small" @click="editRouting">Sửa</button>
          <button class="btn primary small outline" @click="deleteRouting">
            Xóa
          </button>
        </div>
      </span>
    </el-dialog>

    <!-- Mission List Popup -->
    <!-- <el-dialog
      :title="listDialogTitle"
      :visible.sync="missionDialog"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="das-info-title">
        Thông tin đặt phòng {{ bookingInfo.booking_group_code }}
      </div>
      <hr />
      <InfoList :columns="3">
        <InfoListLabel>Tên khách</InfoListLabel>
        <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

        <InfoListLabel>Ngày đến</InfoListLabel>
        <InfoListValue>{{
          $displayDate(bookingInfo.check_in_date)
        }}</InfoListValue>

        <InfoListLabel>Đoàn</InfoListLabel>
        <InfoListValue>{{ bookingInfo.booking_group_name }}</InfoListValue>

        <InfoListLabel>SDT</InfoListLabel>
        <InfoListValue>{{ bookingInfo.phone_number }}</InfoListValue>

        <InfoListLabel>Ngày đi </InfoListLabel>
        <InfoListValue>{{
          $displayDate(bookingInfo.check_out_date)
        }}</InfoListValue>

        <InfoListLabel>Công ty, đại lý du lịch</InfoListLabel>
        <InfoListValue>{{ bookingInfo.agent_name }}</InfoListValue>
      </InfoList>
      <div class="mt-10" style="height: 400px">
        <GridVx
          ref="missionListGrid"
          :columns="dynamicCols"
          dom-layout="scroll"
          :rows="rows"
          class="agGrid"
          @rowClicked="missionRowSelected = true"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="missionDialog = false"
          >
            Đóng
          </button>
          <div v-if="dialogType === 1" class="flex gap-10">
            <button
              class="btn primary small outline"
              :disabled="!missionRowSelected"
              @click="cancelCompleteMission"
            >
              Hủy hoàn thành
            </button>
            <button
              :disabled="!missionRowSelected"
              class="btn primary small"
              @click="openSubDialog(12)"
            >
              Hoàn thành
            </button>
            <button class="btn primary small" @click="openSubDialog(11)">
              Thêm
            </button>
          </div>
          <div v-if="dialogType === 2" class="flex gap-10">
            <button
              :disabled="!missionRowSelected"
              class="btn primary small"
              @click="openHandleRowDialog"
            >
              Xử lý
            </button>
            <button
              :disabled="!missionRowSelected"
              class="btn primary small"
              @click="cancelHandleRow"
            >
              Hủy xử lý
            </button>
            <button class="btn primary small" @click="openSubDialog(21)">
              Thêm
            </button>
          </div>
          <div v-if="dialogType === 3" class="flex gap-10">
            <button class="btn primary small">Lấy danh sách cảnh báo</button>
            <button class="btn primary small" @click="openSubDialog(31)">
              Thêm
            </button>
          </div>
          <div v-if="dialogType === 4" class="flex gap-10">
            <button
              v-if="dialogType === 4"
              :disabled="!missionRowSelected"
              class="btn primary small"
              @click="onSendMessage"
            >
              Gửi
            </button>
            <button
              :disabled="!missionRowSelected"
              class="btn primary small"
              @click="openCancelMissionDialog"
            >
              Hủy
            </button>
            <button class="btn primary small" @click="openSubDialog(41)">
              Thêm
            </button>
          </div>
        </div>
      </span>
    </el-dialog> -->

    <!-- Add mission Popup -->
    <!-- <el-dialog
      title="Thêm xử lý"
      :visible="addHandleDialog"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  <span>Ghi chú</span>
                </div>
                <textarea v-model="handleSubmitForm.note" :rows="3" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addHandleDialog = false"
          >
            Hủy
          </button>
          <button class="btn primary small" @click="addHandle()">Thêm</button>
        </div>
      </span>
    </el-dialog> -->

    <!-- complete Mission Popup -->
    <!-- <el-dialog
      title="Hoàn thành nhiệm vụ"
      :visible="completeMissionDialog"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  <span>Ghi chú</span>
                </div>
                <textarea v-model="completeMissionSubmitForm.note" :rows="3" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="completeMissionDialog = false"
          >
            Hủy
          </button>
          <button class="btn primary small" @click="completeMission()">
            Thêm
          </button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="Hủy tin nhắn"
      :visible="cancelMessageDialog"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  <span>Ghi chú</span>
                </div>
                <textarea v-model="cancelMessageForm.note" :rows="3" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="cancelMessageDialog = false"
          >
            Hủy
          </button>
          <button class="btn primary small" @click="submitCancelMessage()">
            Thêm
          </button>
        </div>
      </span>
    </el-dialog> -->

    <!-- Add mission Popup -->
    <!-- <el-dialog
      :title="addMissionTitle"
      :visible="addMissionDialog"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="das-form-container">
        <div
          v-if="addDialogType === 11 || addDialogType === 13"
          class="das-form-group"
        >
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span>Bộ phận</span>
                </div>
                <el-select
                  v-model="submitForm.department_ids"
                  placeholder=""
                  multiple
                >
                  <el-option
                    v-for="item in departmentOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span>Ngày thực hiện</span>
                </div>
                <div>
                  <MultiCalendar
                    :from-date="submitForm.start_date"
                    :to-date="submitForm.end_date"
                    class="use-icon"
                    @changeDate="onChangeDate"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span>Thời gian thực hiện</span>
                </div>
                <div class="flex gap-20">
                  <TimePicker
                    v-model="submitForm.exe_time"
                    format="HH:mm"
                    @change="changeTime"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  <span>Nội dung</span>
                </div>
                <textarea v-model="submitForm.content" :rows="3" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="addDialogType === 12" class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  <span>Ghi chú</span>
                </div>
                <textarea :rows="3" />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="addDialogType === 21 || addDialogType === 22"
          class="das-form-group"
        >
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  <span>Người gửi</span>
                </div>
                <input v-model="submitForm.sender" type="text" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  <span>Nội dung</span>
                </div>
                <textarea v-model="submitForm.content" :rows="3" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="addDialogType === 31" class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span>Mã</span>
                </div>
                <el-select placeholder="">
                  <el-option :key="9999" :value="null" label="Tất cả" />
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label">
                  <span>Hiển thị cảnh báo</span>
                </div>
                <div class="checkbox-container">
                  <div class="checks-wrap">
                    <input
                      id="adasdvzx"
                      v-model="warningRadioValue"
                      type="radio"
                      value="1"
                    />
                    <label for="adasdvzx">Khi nhận phòng</label>
                  </div>
                  <div class="checks-wrap ml-10">
                    <input
                      id="adasdvzx2"
                      v-model="warningRadioValue"
                      type="radio"
                      value="2"
                    />
                    <label for="adasdvzx2">Khi xem giao dịch</label>
                  </div>
                  <div class="checks-wrap ml-10">
                    <input
                      id="adasdvzx3"
                      v-model="warningRadioValue"
                      type="radio"
                      value="3"
                    />
                    <label for="adasdvzx3">Khi xem chi tiết nhận phòng</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  <span>Nội dung cảnh báo</span>
                </div>
                <textarea style="width: 100%" :rows="3" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="addDialogType === 41" class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span>Người gửi</span>
                </div>
                <input v-model="submitForm.sender" type="text" />
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span>Số điện thoại</span>
                </div>
                <input v-model="submitForm.phone_num" type="text" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  <span>Mục đích</span>
                </div>
                <input v-model="submitForm.purpose" type="text" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  <span>Nội dung</span>
                </div>
                <textarea v-model="submitForm.content" :rows="3" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addMissionDialog = false"
          >
            Đóng
          </button>
          <button
            v-if="!isViewMission"
            class="btn primary small"
            @click="addNewmission(type)"
          >
            Lưu
          </button>
        </div>
      </span>
    </el-dialog> -->

    <!-- Hoa don -->
    <el-dialog
      title="Hoá đơn"
      :visible.sync="temporaryInvoiceDialog"
      :close-on-click-modal="false"
      width="1100px"
    >
      <div class="das-info-title">Thông tin khách</div>
      <InfoList :columns="3">
        <template>
          <InfoListLabel>Tài khoản</InfoListLabel>
          <InfoListValue>Unknown</InfoListValue>
        </template>
      </InfoList>
      <div class="das-form-container">
        <div class="das-form-group border-bottom mt-10">
          <div class="das-form-group-title">Thông tin giao dịch</div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input mb-10">
                <div class="label required">Tên khách</div>
                <div style="display: flex; gap: 10px">
                  <input v-model="temporaryInvoice.full_name" type="text" />
                  <!-- <input v-model="temporaryInvoiceInfo1.lastName" type="text" /> -->
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input mb-10">
                <div class="label">Email</div>
                <input v-model="temporaryInvoice.email" type="text" />
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input mb-10">
                <div class="label">Công ty</div>
                <input v-model="temporaryInvoice.agent_name" type="text" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div>
                <div class="das-form-input mb-10">
                  <div class="label">Địa chỉ</div>
                  <input v-model="temporaryInvoice.address" type="text" />
                </div>
              </div>
              <div>
                <div class="das-form-input mb-10">
                  <div class="label">Mã số thuế</div>
                  <input v-model="temporaryInvoice.tax" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input mb-10">
                <div class="label">Ghi chú</div>
                <textarea
                  v-model="temporaryInvoice.note"
                  type="text"
                  :rows="5"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="das-form-group border-bottom mt-10">
          <div class="das-form-group-title">Thông tin giao dịch</div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="checkbox-container">
                <div class="checkbox-wrap">
                  <input id="dasdasd" v-model="value[0]" type="checkbox" />
                  <label for="dasdasd">Theo phòng gốc</label>
                </div>
                <div class="checkbox-wrap">
                  <input id="cxzvszd" v-model="value[1]" type="checkbox" />
                  <label for="cxzvszd">Theo ngày</label>
                </div>
                <div class="checkbox-wrap">
                  <input id="fasdagg" v-model="value[2]" type="checkbox" />
                  <label for="fasdagg">Theo giao dịch</label>
                </div>
                <div class="checkbox-wrap">
                  <input id="342q2rfse" v-model="value[3]" type="checkbox" />
                  <label for="342q2rfse">Không in giá</label>
                </div>
              </div>
              <div class="checkbox-container mt-10">
                <div class="checks-wrap">
                  <input
                    id="35qrdsz"
                    v-model="radioValue"
                    type="radio"
                    :value="1"
                  />
                  <label for="35qrdsz">Chi tiết</label>
                </div>
                <div class="checks-wrap ml-10">
                  <input
                    id="cpSpdfasdTp6"
                    v-model="radioValue"
                    type="radio"
                    :value="2"
                  />
                  <label for="cpSpdfasdTp6">Gom nhóm</label>
                </div>
                <div class="checks-wrap ml-10">
                  <input
                    id="vxvxzdsf"
                    v-model="radioValue"
                    type="radio"
                    :value="3"
                  />
                  <label for="vxvxzdsf">Tổng</label>
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Ghi chú 2</div>
                <textarea read type="text" :rows="5" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small"
            @click="temporaryInvoiceDialog = false"
          >
            Đóng
          </button>
          <!-- <button class="btn primary small">
            Thông tin xuất hóa đơn từ đặt phòng
          </button> -->
          <button class="btn primary small" @click="downloadProvisionalInvoice">
            In theo mẫu
          </button>
        </div>
      </span>
    </el-dialog>
    <routing-component ref="routingComponent" :routing-index="routingIndex" />
    <mission-component ref="missionComponent" />
    <comment-component ref="commentComponent" />
    <warning-component
      ref="warningComponent"
      :note-data="updateNoteData"
      :booking-status="bookingInfo?.status"
      @updatedNoteData="fetchBookingNote"
      @close="getTextareaWarning"
    />
    <message-component ref="messageComponent" />

    <el-dialog
      title="Sửa thông tin đặt phòng"
      :visible.sync="editReservationDialogVisible"
      :close-on-click-modal="false"
      width="1150px"
      @closed="editReservationDialogVisible = false"
    >
      <BookingRoomForm
        v-if="editReservationDialogVisible"
        ref="BookingRoomForm"
        :action="bookingFormAction(recordData.status)"
        :record-data="recordData"
      />
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="editReservationDialogVisible = false"
          >
            Đóng
          </button>
          <button
            v-show="bookingFormAction(recordData.status)"
            class="btn primary small"
            @click="updateReservation()"
          >
            Cập nhật
          </button>
        </div>
      </span>
    </el-dialog>

    <div style="height: 0; opacity: 0">
      <iframe
        v-if="invoiceDialogVisible"
        width="100%"
        height="100%"
        :src="`/cashier/invoice?id=${bookingInfo.id}&name=${encodeURIComponent(
          temporaryInvoice.full_name ?? ''
        )}&company=${encodeURIComponent(
          temporaryInvoice.agent_name ?? ''
        )}&recode=${encodeURIComponent(
          temporaryInvoice.sub_booking_code ?? temporaryInvoice.recode ?? ''
        )}&phone=${encodeURIComponent(
          temporaryInvoice.phone_number ?? ''
        )}&from=${encodeURIComponent(
          $moment(bookingInfo.check_in_date).format('DD/MM/YYYY')
        )}&to=${encodeURIComponent(
          $moment(bookingInfo.check_out_date).format('DD/MM/YYYY')
        )}`"
      ></iframe>
    </div>
    <div style="height: 0; opacity: 0">
      <iframe
        v-if="provisionalInvoiceDialogVisible"
        ref="provisionalInvoiceIframe"
        width="100%"
        height="100%"
        :src="provisionalInvoiceSrc"
      ></iframe>
    </div>
    <!-- <div style="height: 0; opacity: 0">
      <iframe
        v-if="detailInvoiceDialogVisible"
        width="100%"
        height="100%"
        :src="`/cashier/folio?id=${transactions[0]?.id}`"
      ></iframe>
    </div> -->
  </div>
</template>

<script>
import moment from 'moment'
import BookingRoomForm from '@/components/resources/booking/BookingRoomForm.vue'
import { updateRoomBookingApi } from '@/api/chamber_service/common'
import {
  getCheckoutInspectionByBookingApi,
  createCheckoutInspectionApi,
  cancelCheckoutInspectionApi
} from '@/api/chamber_service/checkoutInspection'
import { getBookingRoom } from '@/api/booking_service/booking'
import { checkAuthorized } from '@/utils/helper'
import {
  checkoutCustomer,
  cancelCheckoutCustomer,
  // eslint-disable-next-line no-unused-vars
  getRoutingList,
  // getComments,
  // getWarningList,
  // getMessages,
  // getMissions,
  // eslint-disable-next-line no-unused-vars
  sendMessage,
  addForm,
  handleRow,
  // eslint-disable-next-line no-unused-vars
  handleCancelRow,
  cancelCompleteMissionApi,
  completeMissionApi,
  getWarningList,
  checkoutGroup,
  getBookingNoteApi,
  cardRoomCheckoutApi
  // updateBookingNoteApi
} from '@/api/cashier_service/postTransaction'
// import { exportProvisionalInvoiceApi } from '@/api/export_service/exportService'
import { getDepartmentApi } from '@/api/userConfig/department'
import RoutingComponent from './components/routingComponent.vue'
import MissionComponent from './components/missionComponent.vue'
import CommentComponent from './components/commentComponent.vue'
import WarningComponent from './components/warningComponent.vue'
import MessageComponent from './components/messageComponent.vue'
// eslint-disable-next-line no-unused-vars
import { downloadFile, openPdfWindow } from '@/utils/file-handler'
import bus from '@/utils/bus'
// import { notifyError } from '@/utils/toast'
export default {
  components: {
    RoutingComponent,
    MissionComponent,
    CommentComponent,
    WarningComponent,
    MessageComponent,
    BookingRoomForm
  },
  props: {
    emitedMoney: {
      type: Number,
      default: 0
    },
    depositMoney: {
      type: Number,
      default: 0
    },
    checkoutPermitFromApi: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkoutInspection: null,
      checkoutInspectionLoaded: false,
      checkoutInspectionLoadFailed: false,
      checkoutInspectionBusy: false,
      checkoutInspectionLoadToken: 0,
      checkoutInspectionDialog: false,
      checkoutInspectionSlipData: {},
      invoiceDialogVisible: false,
      provisionalInvoiceDialogVisible: false,
      provisionalInvoiceSrc: '',
      detailInvoiceDialogVisible: false,
      warningDescArray: [],
      recordData: {},
      editReservationDialogVisible: false,
      // author
      checkAuthorPermission: false,
      checkAuthorMission: false,
      checkAuthorComment: false,
      checkAuthorWarning: false,
      //
      routingIndex: 0,
      completeMissionSubmitForm: {
        note: null
      },
      completeMissionDialog: false,
      temporaryInvoice: {
        full_name: null,
        email: null,
        agent_name: null,
        address: null,
        tax: null,
        note: null
      },
      departmentOptions: [],
      cancelMessageDialog: false,
      addHandleDialog: false,
      missionRowSelected: false,
      cancelMessageForm: {
        note: null
      },
      submitForm: {
        sub_booking_group_id: null,
        sender: null,
        content: null,
        // mission
        department_ids: null,
        end_date: null,
        start_date: null
      },
      handleSubmitForm: {
        note: null
      },
      missionCols: [
        {
          headerName: 'STT',
          field: 'no',
          width: 50
        },
        {
          headerName: 'Bộ phận',
          field: 'department_name',
          width: 200
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          width: 100
        },
        {
          headerName: 'Nội dung',
          field: 'content',
          width: 100
        },
        {
          headerName: 'Thời gian thực hiện',
          field: 'exe_time',
          width: 200,
          cellRenderer: params => {
            return moment(params.value).format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          headerName: 'Người thực hiện',
          field: 'implementer',
          width: 150
        },
        {
          headerName: 'Thời gian hoàn thành',
          field: 'completion_time',
          width: 200,
          cellRenderer: params => {
            return params.value
              ? moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : ''
          }
        },
        {
          headerName: 'Người tạo',
          field: 'create_user_name',
          width: 150
        },
        {
          headerName: 'Thời gian tạo',
          field: 'create_date',
          width: 200,
          cellRenderer: params => {
            return params.value
              ? moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : ''
          }
        },
        {
          headerName: 'Người hủy',
          field: 'cancel_user_name',
          width: 150
        },
        {
          headerName: 'Thời gian hủy',
          field: 'cancel_time',
          width: 200,
          cellRenderer: params => {
            return params.value
              ? moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : ''
          }
        },
        {
          headerName: 'Ghi chú',
          field: 'note'
        }
      ],
      commentCols: [
        {
          headerName: 'Từ',
          field: 'create_date',
          width: 120
        },
        {
          headerName: 'Người tạo',
          field: 'sender',
          width: 120
        },
        {
          headerName: 'Thời gian tạo',
          field: 'demo',
          width: 120
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          width: 120
        },
        {
          headerName: 'Nội dung',
          field: 'content'
        },
        {
          headerName: 'Người hủy, xử lý',
          field: 'demo',
          width: 160
        },
        {
          headerName: 'Thời gian hủy, xử lý',
          field: 'demo',
          width: 160
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          width: 120
        }
      ],
      warningCols: [
        {
          headerName: 'Tên khách chính',
          field: 'demo'
        },
        {
          headerName: 'SĐT',
          field: 'demo'
        },
        {
          headerName: 'Ngày đến',
          field: 'demo'
        },
        {
          headerName: 'Ngày đi',
          field: 'demo'
        },
        {
          headerName: 'Phòng',
          field: 'demo'
        },
        {
          headerName: 'TA/Công ty',
          field: 'demo'
        },
        {
          headerName: 'Đoàn',
          field: 'demo'
        }
      ],
      messageCols: [
        {
          // headerName: this.$t('grid.column.subBookingCode'),
          headerName: 'Người gửi',
          field: 'sender'
        },
        {
          headerName: 'Mục đích',
          field: 'purpose'
        },
        {
          headerName: 'Số điện thoại',
          field: 'phone_num'
        },
        {
          headerName: 'Nội dung',
          field: 'content',
          minWidth: 500
        }
      ],
      radioValue: 1,
      dialogType: null,
      listDialogTitle: null,
      value: [false, false, false],
      temporaryInvoiceInfo1: {
        firstName: null,
        lastName: null,
        email: null,
        company: null,
        address: null,
        taxCode: null,
        note: null
      },
      warningRadioValue: '1',
      addMissionDialog: false,
      rows: [],
      temporaryInvoiceInfo: [],
      temporaryInvoiceDialog: false,
      missionDialog: false,
      addMissionTitle: null,
      isViewMission: false,
      addDialogType: null,
      dynamicCols: [],
      customerInfo: {
        surplus: null,
        sub_booking_code: null,
        full_name: null,
        room_num: null
      },
      routingCols: [
        {
          headerName: this.$t('grid.column.fromPageTransaction'),
          field: 'trans_page_org_code'
        },
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'sub_booking_group_des_code'
        },
        {
          headerName: this.$t('grid.column.subTransactionCode'),
          field: 'sub_transaction_code'
        },
        {
          headerName: this.$t('grid.column.toFolio'),
          field: 'trans_page_des_code'
        },
        {
          headerName: this.$t('grid.column.toPageTransaction'),
          field: 'trans_page_org_code'
        },
        {
          headerName: this.$t('grid.column.toRoom'),
          field: 'transaction_code'
        }
      ],
      routingRows: [],
      // DIALOG
      routingDialog: false,
      addRoutingDialog: false,

      // update note
      updateNoteData: {
        booking_id: null,
        note: '',
        is_able_update_note: false
      }
    }
  },
  computed: {
    selectedBookingId() {
      return this.isRowSelected && this.bookingInfo.id ? this.bookingInfo.id : null
    },
    checkoutInspectionStatus() {
      return this.checkoutInspection?.status || null
    },
    checkoutInspectionStatusText() {
      if (!this.selectedBookingId) return 'Chưa yêu cầu'
      if (this.checkoutInspectionLoadFailed) return 'Không tải được trạng thái'
      if (!this.checkoutInspectionLoaded) return 'Đang tải...'
      switch (this.checkoutInspectionStatus) {
        case 'PENDING': return 'Chờ kiểm'
        case 'DONE': return 'Đã kiểm – có phát sinh'
        case 'DONE_NO_CHARGE': return 'Đã kiểm – không phát sinh'
        case 'CANCELLED':
        default: return 'Chưa yêu cầu'
      }
    },
    showRequestCheckoutInspection() {
      return !this.selectedBookingId || (this.checkoutInspectionLoaded &&
        (!this.checkoutInspectionStatus || this.checkoutInspectionStatus === 'CANCELLED'))
    },
    canRequestCheckoutInspection() {
      return this.selectedBookingId &&
        this.showRequestCheckoutInspection &&
        Number(this.bookingInfo.status) === 2 &&
        !this.bookingInfo.checked_out
    },
    hasCheckoutInspectionSlip() {
      return this.checkoutInspectionStatus === 'DONE' ||
        this.checkoutInspectionStatus === 'DONE_NO_CHARGE'
    },
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    transactions() {
      return this.$store.getters['transactions']
    },
    isRowSelected() {
      return this.$store.getters['rowSelected']
    },
    checkoutPermit() {
      let data = false
      // const checkDate =
      //   this.$displayDate(this.bookingInfo.check_out_date) ===
      //   this.$displayDate(new Date())
      if (this.emitedMoney === 0 && this.checkoutPermitFromApi) {
        data = true
      }
      return data
    }
  },
  watch: {
    selectedBookingId: {
      immediate: true,
      handler(id) {
        this.checkoutInspection = null
        this.checkoutInspectionLoaded = false
        this.checkoutInspectionLoadFailed = false
        this.checkoutInspectionDialog = false
        this.checkoutInspectionLoadToken += 1
        if (id) this.loadCheckoutInspection(id)
      }
    },
    addMissionDialog() {
      this.addMissionDialog ? null : this.resetSubmitForm()
    },
    addHandleDialog() {
      this.addHandleDialog ? null : this.$nullValueInObj(this.handleSubmitForm)
    },
    bookingInfo() {
      if (this.bookingInfo.id) {
        Object.assign(this.temporaryInvoice, this.bookingInfo)
        // data for edit reservation
        // this.getRecordData()
        // data for warning textarea
        this.getTextareaWarning()
        this.fetchBookingNote()
      }
    }
  },
  mounted() {
    this.checkAuthorPermission = checkAuthorized('TRANSACTION_MISSION')
    this.checkAuthorComment = checkAuthorized('TRANSACTION_COMMENT')
    this.checkAuthorWarning = checkAuthorized('TRANSACTION_WARNING')

    bus.$on('post_transaction/show_print_invoice_dialog', () => {
      this.downloadProvisionalInvoice()
    })
    bus.$on(
      'post_transaction/show_print_provisional_invoice_dialog',
      this.printProvisionalInvoice
    )
    window.addEventListener('message', this.handleProvisionalInvoiceMessage)
    // bus.$on('post_transaction/show_print_detail_invoice_dialog', () => {
    //   this.downloadDetailInvoice()
    // })
  },
  beforeDestroy() {
    bus.$off(
      'post_transaction/show_print_provisional_invoice_dialog',
      this.printProvisionalInvoice
    )
    window.removeEventListener('message', this.handleProvisionalInvoiceMessage)
  },
  methods: {
    vxConfirmAsync(message, resolveText, rejectText) {
      return new Promise((resolve, reject) => {
        this.$vxConfirm(message, { resolveText, rejectText, resolve, reject: () => reject(new Error('cancel')) })
      })
    },
    async loadCheckoutInspection(id = this.selectedBookingId) {
      if (!id) return
      const token = ++this.checkoutInspectionLoadToken
      this.checkoutInspectionLoaded = false
      this.checkoutInspectionLoadFailed = false
      try {
        const response = await getCheckoutInspectionByBookingApi(id)
        if (response?.is_error) throw new Error(response.message)
        if (token === this.checkoutInspectionLoadToken && id === this.selectedBookingId) {
          this.checkoutInspection = response.data || null
          this.checkoutInspectionLoaded = true
        }
      } catch (error) {
        if (token === this.checkoutInspectionLoadToken && id === this.selectedBookingId) {
          this.checkoutInspectionLoadFailed = true
          this.$message({ type: 'error', message: 'Không tải được trạng thái kiểm phòng CO.' })
        }
      }
    },
    checkoutInspectionErrorMessage(error) {
      const code = error.response?.data?.message || error.message
      if (code === 'bookingNotFound') return 'Không tìm thấy đặt phòng.'
      if (code === 'roomCheckedOut') return 'Phòng đã trả, không thể yêu cầu kiểm phòng.'
      if (code === 'requestCancelled') return 'Yêu cầu kiểm phòng đã được hủy.'
      return 'Không xử lý được yêu cầu kiểm phòng CO. Vui lòng thử lại.'
    },
    async requestCheckoutInspection() {
      if (!this.canRequestCheckoutInspection || this.checkoutInspectionBusy) return
      const id = this.selectedBookingId
      const room = this.bookingInfo.room_num
      this.checkoutInspectionBusy = true
      try {
        const response = await createCheckoutInspectionApi(id)
        if (response?.is_error) throw new Error(response.message)
        if (response.data?.status === 'PENDING') {
          this.$message({ type: 'success', message: `Đã gửi yêu cầu kiểm phòng ${room}.` })
        }
      } catch (error) {
        this.$message({ type: 'error', message: this.checkoutInspectionErrorMessage(error) })
      } finally {
        this.checkoutInspectionBusy = false
        if (id === this.selectedBookingId) await this.loadCheckoutInspection(id)
      }
    },
    async cancelCheckoutInspection() {
      if (this.checkoutInspectionStatus !== 'PENDING' || this.checkoutInspectionBusy) return
      const id = this.selectedBookingId
      const room = this.checkoutInspection.room_num || this.bookingInfo.room_num
      const requestId = this.checkoutInspection.request_id
      try {
        await this.vxConfirmAsync(`Hủy yêu cầu kiểm phòng ${room}?`, 'Hủy yêu cầu kiểm', 'Quay lại')
      } catch (error) {
        return
      }
      this.checkoutInspectionBusy = true
      try {
        const response = await cancelCheckoutInspectionApi(requestId)
        if (response?.is_error) {
          const apiError = new Error(response.message)
          apiError.response = { data: response }
          throw apiError
        }
        this.$message({ type: 'success', message: `Đã hủy yêu cầu kiểm phòng ${room}.` })
      } catch (error) {
        if (error.response?.data?.message === 'alreadyInspected') {
          const inspected = error.response.data.data
          if (inspected?.slip) this.checkoutInspectionSlipData = inspected
          try {
            await this.vxConfirmAsync(`Phòng ${room} đã được HK kiểm, không thể hủy.`, 'Xem phiếu', 'Đóng')
            if (inspected?.slip && id === this.selectedBookingId) this.checkoutInspectionDialog = true
          } catch (dialogError) {
            // Người dùng đóng thông báo.
          }
        } else {
          this.$message({ type: 'error', message: this.checkoutInspectionErrorMessage(error) })
        }
      } finally {
        this.checkoutInspectionBusy = false
        if (id === this.selectedBookingId) await this.loadCheckoutInspection(id)
      }
    },
    openCheckoutInspectionSlip() {
      if (!this.hasCheckoutInspectionSlip || !this.checkoutInspection?.slip) return
      this.checkoutInspectionSlipData = this.checkoutInspection
      this.checkoutInspectionDialog = true
    },
    formatCheckoutInspectionTime(value) {
      return value ? moment(value).format('DD/MM/YYYY HH:mm') : ''
    },
    checkoutInspectionGroupName(group) {
      return {
        MINIBAR: 'Minibar',
        COMPENSATION: 'Đền bù',
        LAUNDRY: 'Giặt là',
        ROOM_CARD: 'Thẻ phòng'
      }[group] || group
    },
    async fetchBookingNote() {
      const data = await getBookingNoteApi(this.bookingInfo.id)
      this.updateNoteData = data.data
    },
    bookingFormAction(status) {
      if (status === 1) return 'edit'
      if (status === 2) return 'edit-checked-in'
      return null
    },
    async getTextareaWarning() {
      const data = await getWarningList({
        sub_booking_group_id: this.bookingInfo.id
      })
      const rows = data.data || []
      this.warningDescArray = rows.map(item => item.content)
    },
    async getRecordData() {
      const data = await getBookingRoom(this.bookingInfo.id)
      this.recordData = data.data
    },
    async updateReservation() {
      const payload = this.$refs.BookingRoomForm.dehydrateForm()
      await updateRoomBookingApi(this.bookingInfo.id, payload)
        .then(res => {
          // console.log(res)
          this.$message({
            message: 'Sửa thông tin thành công',
            type: 'success'
          })
          this.$store.dispatch('cashier/changeKey')
          this.editReservationDialogVisible = false
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: 'Sửa thông tin thất bại',
            type: 'error'
          })
        })
    },
    openMessageDialog() {
      this.$refs.messageComponent.getInitData()
    },
    openWarningDialog() {
      this.$refs.warningComponent.getInitData()
    },
    openCommentDialog() {
      this.$refs.commentComponent.getInitData()
    },
    openMissionDialog() {
      this.$refs.missionComponent.getInitData()
    },
    async completeMission() {
      const gridApi = this.$refs.missionListGrid.gridApi
      const id = gridApi.getSelectedRows()[0].id
      await completeMissionApi(id, this.completeMissionSubmitForm)
        .then(async res => {
          this.completeMissionDialog = false
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async cancelCompleteMission() {
      const gridApi = this.$refs.missionListGrid.gridApi
      const id = gridApi.getSelectedRows()[0].id
      await cancelCompleteMissionApi(id)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    changeTime(time) {
      this.submitForm.exe_time = time.displayTime
    },
    onChangeDate(from, to) {
      this.submitForm.start_date = from
      this.submitForm.end_date = to
    },
    async getDepartmentOptions() {
      const data = await getDepartmentApi()
      this.departmentOptions = data.data || []
    },
    async onSendMessage() {
      const gridApi = this.$refs.missionListGrid.gridApi
      const id = gridApi.getSelectedRows()[0].id
      await sendMessage(id)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async addHandle() {
      const gridApi = this.$refs.missionListGrid.gridApi
      const id = gridApi.getSelectedRows()[0].id
      let url = ''
      switch (this.dialogType) {
        case 2:
          url = `/cashier-service/v1/room-comment/${id}/handle`
          break
      }
      await handleRow(url, this.handleSubmitForm)
        .then(async res => {
          const message = res.message
          this.addHandleDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    resetSubmitForm() {
      this.$nullValueInObj(this.submitForm)
    },
    openHandleRowDialog() {
      this.addHandleDialog = true
    },
    async editReservationInfo() {
      await this.getRecordData()
      this.editReservationDialogVisible = true
      this.$refs.BookingRoomForm.hydrateForm(this.recordData)
      // this.$vxConfirm('Bạn muốn chuyển sang trang sửa đặt phòng?', () => {
      //   this.$router.push({
      //     path: '/reservation/new_reservation',
      //     query: {
      //       action: 'edit',
      //       id: this.bookingInfo?.id || null
      //     }
      //   })
      // })
    },
    async cancelHandleRow() {
      const gridApi = this.$refs.missionListGrid.gridApi
      const id = gridApi.getSelectedRows()[0].id
      await handleCancelRow(`/cashier-service/v1/room-comment/${id}/cancel`)
        .then(async res => {
          const message = res.message
          this.addHandleDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async openCancelMissionDialog() {
      this.cancelMessageDialog = true
    },
    async submitCancelMessage() {
      const gridApi = this.$refs.missionListGrid.gridApi
      const id = gridApi.getSelectedRows()[0].id
      await handleRow(
        `/cashier-service/v1/room-message/${id}/cancel`,
        this.cancelMessageForm
      )
        .then(async res => {
          const message = res.message
          this.cancelMessageDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async addNewmission(type = null) {
      this.submitForm.sub_booking_group_id = this.bookingInfo.id
      let url = ''
      switch (this.dialogType) {
        case 1:
          url = '/booking-service/v1/missions/insert'
          break
        case 2:
          url = '/cashier-service/v1/room-comment'
          break
        case 4:
          url = '/cashier-service/v1/room-message'
      }
      await addForm(url, this.submitForm)
        .then(async res => {
          const message = res.message
          this.addMissionDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async openSubDialog(type = null) {
      if (type) {
        this.addDialogType = type
        switch (type) {
          case 11:
            await this.getDepartmentOptions()
            this.addMissionTitle = 'Thêm nhiệm vụ'
            this.addMissionDialog = true
            break
          case 12:
            this.addMissionTitle = 'Hoàn thành nhiệm vụ'
            this.completeMissionDialog = true
            break
          case 13:
            await this.getDepartmentOptions()
            this.addMissionTitle = 'Xem nhiệm vụ'
            this.addMissionDialog = true
            break
          case 21:
            this.addMissionTitle = 'Thêm bình luận'
            this.addMissionDialog = true
            break
          case 22:
            this.addMissionTitle = 'Xem bình luận'
            this.addMissionDialog = true
            break
          case 31:
            this.addMissionTitle = 'Thêm cảnh báo'
            this.addMissionDialog = true
            break
          case 41:
            this.addMissionTitle = 'Thêm tin nhắn'
            this.addMissionDialog = true
            break
        }
      }
    },
    openTemporaryInvoiceDialog() {
      this.temporaryInvoiceInfo = [
        {
          label: 'Đặt phòng',
          value: 19264
        },
        {
          label: 'Xác nhận',
          value: 10001
        },
        {
          label: 'Phòng',
          value: 201
        },
        {
          label: 'Ngày đến',
          value: '16/03/2023'
        },
        {
          label: 'Ngày đi',
          value: '18/03/2023'
        },
        {
          label: 'Đoàn',
          value: 'Hải phòng'
        }
      ]
      this.temporaryInvoiceDialog = true
    },
    async onCheckoutCustomer() {
      const bookingId = this.bookingInfo.id
      const room = this.bookingInfo.room_num
      let pendingInspection = false
      try {
        const response = await getCheckoutInspectionByBookingApi(bookingId)
        pendingInspection = !response?.is_error && response.data?.status === 'PENDING'
      } catch (error) {
        // Lỗi kiểm phòng không chặn luồng trả phòng hiện có.
      }
      if (pendingInspection) {
        try {
          await this.vxConfirmAsync(`Phòng ${room} chưa được HK kiểm.`, 'Vẫn check-out', 'Quay lại xử lý')
        } catch (error) {
          return
        }
      }
      const data = {
        ids: [bookingId]
      }
      await checkoutCustomer(data)
        .then(async res => {
          const message = res.message
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.$store.dispatch('cashier/changePostTransactionListIndex')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
      await cardRoomCheckoutApi()
    },
    async onCancelCheckoutCustomer() {
      // if (!this.checkCustomerRowSelected()) return
      const id = this.bookingInfo.id
      await cancelCheckoutCustomer(id)
        .then(async res => {
          const message = res.message
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.$store.dispatch('cashier/changePostTransactionListIndex')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onCheckoutGroup() {
      this.$vxConfirm(this.$t('alert.groupCheckoutMaster'), async () => {
        await checkoutGroup(this.bookingInfo.id)
          .then(async res => {
            const message = res.message
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
            this.$store.dispatch('cashier/changePostTransactionListIndex')
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async openRoutingDialog() {
      this.routingIndex += 1
      this.$refs.routingComponent.routingDialog = true
    },
    // async openMissionDialog(type) {
    //   // if (!this.checkCustomerRowSelected()) return
    //   this.dialogType = type
    //   this.dynamicCols = []
    //   switch (type) {
    //     // 1 - Nhiem vu
    //     // 2 - Binh luan
    //     // 3 - Canh bao
    //     // 4 - Tin nhan
    //     case 1:
    //       this.listDialogTitle = 'Nhiệm vụ'
    //       Object.assign(this.dynamicCols, this.missionCols)
    //       // eslint-disable-next-line no-case-declarations
    //       const data1 = await getMissions({
    //         subBookingGroupId: this.bookingInfo.id
    //       })
    //       this.rows = data1.data
    //       break
    //     // case 12:
    //     //   this.addMissionTitle = 'Hoàn thành nhiệm vụ'
    //     //   Object.assign(this.dynamicCols, this.missionCols)
    //     //   break
    //     case 2:
    //       this.listDialogTitle = 'Bình luận'
    //       Object.assign(this.dynamicCols, this.commentCols)
    //       // eslint-disable-next-line no-case-declarations
    //       const data2 = await getComments({
    //         sub_booking_group_id: this.bookingInfo.id
    //       })
    //       this.rows = data2.data
    //       break
    //     case 3:
    //       this.listDialogTitle = 'Cảnh báo'
    //       Object.assign(this.dynamicCols, this.warningCols)
    //       // eslint-disable-next-line no-case-declarations
    //       const data3 = await getWarningList({
    //         sub_booking_group_id: this.bookingInfo.id
    //       })
    //       this.rows = data3.data
    //       break
    //     case 4:
    //       this.listDialogTitle = 'Tin nhắn'
    //       Object.assign(this.dynamicCols, this.messageCols)
    //       // eslint-disable-next-line no-case-declarations
    //       const data4 = await getMessages({
    //         sub_booking_group_id: this.bookingInfo.id
    //       })
    //       this.rows = data4.data
    //       break
    //   }
    //   this.missionDialog = true
    // },
    addRouting() {
      // if (!this.checkRoutingGridRowSelected()) return
      // this.addRoutingDialog = true
      this.$refs.routingComponent.addRoutingDialog = true
    },
    editRouting() {
      // if (!this.checkRoutingGridRowSelected()) return
      this.addRoutingDialog = true
    },
    deleteRouting() {
      // if (!this.checkRoutingGridRowSelected()) return
      this.$message({
        message: 'Xóa thành công',
        type: 'success'
      })
    },
    downloadProvisionalInvoice() {
      this.invoiceDialogVisible = true
      setTimeout(() => {
        this.invoiceDialogVisible = false
      }, 1000)
      // exportProvisionalInvoiceApi({
      //   subBookingGroupId: this.bookingInfo.id,
      //   transactionInfo: {
      //     ...this.temporaryInvoice,
      //     customerName: this.temporaryInvoice.full_name
      //   }
      // })
      //   .then(res => {
      //     openPdfWindow(res)
      //   })
      //   .catch(err => {
      //     notifyError(err.response?.data?.message)
      //   })
    },
    printProvisionalInvoice() {
      this.provisionalInvoiceDialogVisible = false
      this.provisionalInvoiceSrc = `/cashier/provisional-invoice?id=${this.bookingInfo.id}&name=${encodeURIComponent(
        this.temporaryInvoice.full_name ?? ''
      )}&company=${encodeURIComponent(
        this.temporaryInvoice.agent_name ?? ''
      )}&recode=${encodeURIComponent(
        this.temporaryInvoice.sub_booking_code ?? this.temporaryInvoice.recode ?? ''
      )}&phone=${encodeURIComponent(
        this.temporaryInvoice.phone_number ?? ''
      )}&from=${encodeURIComponent(
        this.$moment(this.bookingInfo.check_in_date).format('DD/MM/YYYY')
      )}&to=${encodeURIComponent(
        this.$moment(this.bookingInfo.check_out_date).format('DD/MM/YYYY')
      )}`
      this.$nextTick(() => {
        this.provisionalInvoiceDialogVisible = true
      })
    },
    handleProvisionalInvoiceMessage(event) {
      if (
        event.origin !== window.location.origin ||
        !this.$refs.provisionalInvoiceIframe ||
        event.source !== this.$refs.provisionalInvoiceIframe.contentWindow
      ) {
        return
      }
      const { type, message } = event.data || {}
      if (type !== 'provisional-invoice/done' && type !== 'provisional-invoice/error') {
        return
      }
      this.provisionalInvoiceDialogVisible = false
      this.provisionalInvoiceSrc = ''
      if (type === 'provisional-invoice/error') {
        this.$message({
          type: 'error',
          message: `In hóa đơn tạm tính thất bại${message ? `: ${message}` : ''}`
        })
      }
    },
    downloadDetailInvoice() {
      this.detailInvoiceDialogVisible = true
      setTimeout(() => {
        this.detailInvoiceDialogVisible = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkout-inspection-status {
  margin: 8px 0;
  font-size: 12px;
}
.checkout-inspection-actions {
  flex-wrap: wrap;
}
.checkout-inspection-meta {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.checkout-inspection-label {
  color: #909399;
}
.checkout-inspection-divider {
  border-top: 1px solid #e4e7ed;
  margin: 14px 0;
}
.checkout-inspection-total {
  margin-top: 10px;
  text-align: right;
  font-weight: bold;
}
.checkout-inspection-note {
  margin-top: 16px;
  font-size: 12px;
  color: #909399;
}
.warnings-wrap {
  background-color: #f0f0f5;
  height: 100px;
  overflow: auto;
  margin: 0;
  padding: 10px 10px 10px 30px;
  font-size: 14px;
  border-radius: 5px;
  word-wrap: break-word;
  li {
    max-width: 314px;
    // background: red;
    // max-width: 95%;
  }
  // &::-webkit-scrollbar {
  //   display: none;
  // }
}
.sub-button-container {
  width: 310px;
  display: flex;
  flex-direction: column;
  .sub-button-wrap {
    flex-wrap: wrap;
    align-items: space-evenly;
    // border: 1px solid red;
    border-radius: 5px;
    // padding: 10px;
    // box-sizing: border-box;
  }
}
</style>
